export * from "./UpdateDoctor.async";
